import { render, staticRenderFns } from "./NewCoupon.vue?vue&type=template&id=5d83f5b1&"
import script from "./NewCoupon.vue?vue&type=script&lang=js&"
export * from "./NewCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports